import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Catch-all route. Unknown /dashboard/* paths (old links, the Google signup
// landing /dashboard/start) still bounce into the app like before. Any other
// unknown URL shows a real "not found" page marked noindex, so search engines
// don't index made-up URLs as copies of the homepage (soft 404s).
const NotFound = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/dashboard')) return <Navigate to="/dashboard" replace />;

  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1rem', padding: '2rem', textAlign: 'center' }}>
      <Helmet>
        <title>Page not found | dmyor</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 style={{ margin: 0 }}>Page not found</h1>
      <p style={{ margin: 0, opacity: 0.7 }}>This page doesn't exist or has moved.</p>
      <p style={{ margin: 0 }}>
        <Link to="/home">Go to the homepage</Link> · <Link to="/blog">Read the blog</Link>
      </p>
    </div>
  );
};

export default NotFound;
